import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Nav from './nav/Nav';
import Footer from './footer/Footer';
import styles from "./styles.module.css";
import { ToastContainer } from 'react-toastify';
import { LoadingPage } from 'src/components';
import { isRTL} from 'src/utils/global';


const MainLayout = () => {

    return (
        <div className={` ${styles.contentContainer} ${isRTL() ? [styles.rtl, "rtl"].join(" ") : ''}`}>
            <Nav />
            <main>
                <Suspense fallback={<LoadingPage />}>
                    <Outlet />
                </Suspense>
            </main>
            <Footer />
            <ToastContainer closeButton={false} />
        </div>
    );
}
export default MainLayout;
